import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { CurrentUser } from '@/types'

interface AuthState {
  user: CurrentUser | null
  setUser: (user: CurrentUser | null) => void
  setToken: (token: string) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      setUser: (user) => set({ user }),
      setToken: (token) =>
        set((state) => (state.user ? { user: { ...state.user, token } } : state)),
      logout: () => set({ user: null }),
    }),
    { name: 'cg-auth' },
  ),
)
